module.exports = __webpack_public_path__ + "img/hair_back_female_wavy_long_mask.8feb6419.png";